enum OutlookHosts {
  WEB_APP = 'OutlookWebApp',
  APP = 'Outlook',
}

export function isHostedInWeb() {
  const hostName = Office.context?.mailbox?.diagnostics?.hostName;
  if (!hostName) {
    return false;
  }

  return hostName === OutlookHosts.WEB_APP;
}
